<template>
  <collapse-portlet title="Metadata" icon="" :expanded="false">
    <vjs-modal name="metadata_update_processing" title="Metadata Processing">
      <template #body-content>
        <p>
          Your metadata update is being processed. For larger files this can take a few minutes.
          It is safe to close this modal, your storage asset will still update once complete.
        </p>
        <div class="text-center">
          <div class="spinner-border" role="status">
            <span class="sr-only">Loading...</span>
          </div>
        </div>
      </template>
    </vjs-modal>
    <vjs-modal name="metadata_update_failed" title="Metadata Update Failed">
      <template #body-content>
        <p>
          We were unable to update metadata for this file. Please contact SharpStream Support.
        </p>
      </template>
    </vjs-modal>
    <div v-if="storage_asset" class="form">
      <div class="row">
        <div class="col-xs-12 col-sm-6">
          <div class="form-group">
            <label>Title</label>
            <input v-model="tags.title" name="title"
                   type="text"
                   class="form-control">
          </div>
          <div class="form-group">
            <label>Artist / Author</label>
            <input v-model="tags.artist" name="artist"
                   type="text"
                   class="form-control">
            <span v-show="errors.has('artist')" class="text-ss-danger">{{ errors.first('artist') }}</span>
          </div>
          <div class="form-group">
            <label>Album</label>
            <input v-model="tags.album" name="album"
                   type="text"
                   class="form-control">
          </div>
          <div class="form-group">
            <label>Genre</label>
            <input v-model="tags.genre" name="genre"
                   type="text"
                   class="form-control">
          </div>
          <div class="form-group">
            <label>Date / Year</label>
            <input v-model="tags.year" v-validate=""
                   name="year"
                   type="text" class="form-control">
          </div>
        </div>
        <div class="col-xs-12 col-sm-6">
          <div class="form-group">
            <label>Publisher</label>
            <input v-model="tags.publisher" v-validate=""
                   name="publisher"
                   type="text" class="form-control">
          </div>
          <div class="form-group">
            <label>Comment</label>
            <textarea v-model="tags.comment" name="comment"
                      class="form-control"
                      rows="3" />
          </div>
          <div class="form-group">
            <label>Copyright</label>
            <textarea v-model="tags.copyright" name="comment"
                      class="form-control"
                      rows="3" />
          </div>
        </div>
        <div class="col-xs-12 col-sm-6">
          <button type="button" class="btn-save-meta btn btn-ss-standout mt-ladda-btn ladda-button"
                  data-style="expand-right"
                  @click.prevent="saveMetadata">
            <span class="ladda-label">Save Metadata</span>
          </button>
        </div>
      </div>
    </div>
  </collapse-portlet>
</template>

<script>
import Ladda from 'ladda';
import 'ladda/dist/ladda-themeless.min.css';
import VeeValidate from "vee-validate";
import VueTheMask from "vue-the-mask";
import CollapsePortlet from "VueComponents/CollapsePortlet";
import VjsModal from "VueModals/VjsModal";

Vue.use(VueTheMask);
Vue.use(VeeValidate, { fieldsBagName: "metadataForm" });

export default {
  components: { VjsModal, CollapsePortlet },
  props: {
    storageUuid: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      tags: {},
      storage_asset: null,
    };
  },
  computed: {
    metadata() {
      return this.storage_asset?.ffmpeg_details?.tags;
    },
    ffmpegData() {
      return this.storage_asset?.ffmpeg_details;
    },
  },
  mounted() {
    this.loadStorageAsset();
    // AudioManager triggers this when job is complete
    EventBus.$on(`metadata_updated_${this.storageUuid}`, () => {
      this.loadStorageAsset();
      this.hideModal("metadata_update_processing");
    });

    EventBus.$on(`metadata_failed_${this.storageUuid}`, () => {
      this.loadStorageAsset();
      this.hideModal("metadata_update_processing");
      this.fireModal("metadata_update_failed");
    });
  },
  methods: {
    async loadStorageAsset() {
      try {
        const response = await axios.get(`/api/v1/storage/${this.storageUuid}`);
        this.storage_asset = response.data.data;
        this.mapTags();
      } catch (error) {
        window.handleAxiosError(error);
      }
    },
    saveMetadata() {
      const save_button_ladda = Ladda.create(document.querySelector('.btn-save-meta'));
      save_button_ladda.start();

      axios.post(`/api/v1/metadata`, {
        metadata: this.tags,
        storage_uuid: this.storageUuid,
      }).then(() => {
        this.fireModal("metadata_update_processing");
        save_button_ladda.stop();
      }).catch((error) => {
        window.handleAxiosError(error);
        save_button_ladda.stop();
      });
    },
    convertToSeconds(time) {
      const a = time.split(":"); // split it at the colons
      // minutes are worth 60 seconds. Hours are worth 60 minutes.
      return +a[0] * 60 * 60 + +a[1] * 60 + +a[2];
    },
    mapTags() {
      this.tags = {
        title: this.metadata?.title,
        album: this.metadata?.album,
        genre: this.metadata?.genre,
        artist: this.metadata?.artist ? this.metadata.artist : this.metadata?.author,
        comment: this.metadata?.comment,
        year: this.metadata?.year ? this.metadata.year : this.metadata?.date,
        publisher: this.metadata?.publisher,
        copyright: this.metadata?.copyright,
      };
    },
  },
};
</script>
